module.exports = __webpack_public_path__ + "static/media/19ESCAP50.23dc677f.jpg";